import * as React from 'react';
import { Dispatch, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ElementLoader } from 'ui';
import { ApplicationState } from 'app/types-store';
import { actionCreators } from '../actions';
import { CaseDraftsTile } from './case-drafts-tile';
import { IntlShape } from 'react-intl';
import { MyCaseDraftsTranslation } from 'app/area/my-case-drafts/constants';
import styles from './case-drafts-tiles.scss';

interface CaseDraftsTilesProps {
  translation: MyCaseDraftsTranslation;
  intl: IntlShape;
}

export const CaseDraftsTiles = ({ translation, intl }: CaseDraftsTilesProps) => {
  const dispatch: Dispatch<any> = useDispatch();
  const { pathname } = useLocation();
  const defaultTableState = { rows: [], fetching: false, deleting: false };
  const { rows, fetching } = useSelector(
    (state: ApplicationState) => state.myCaseDrafts?.caseDraftsTable ?? defaultTableState
  );

  const tileListRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    dispatch(actionCreators.loadDrafts(translation.my_case_drafts_fail_to_load));
  }, [dispatch, pathname]);

  const onDelete = useCallback((draftId: number) => {
    dispatch(actionCreators.deleteDraft(draftId, translation.my_case_drafts_fail_to_delete));
  }, [dispatch, translation]);

  if (fetching) {
    return <ElementLoader />;
  }

  if (!rows.length) {
    return <p className="no-content">{translation.my_case_drafts_no_results}</p>;
  }

  return (
    <div className={styles.caseDraftsWrapper} ref={tileListRef}>
      {rows.map(row => (
        <CaseDraftsTile
          key={row.draftId}
          row={row}
          onDelete={onDelete}
          translation={translation}
          intl={intl}
          portalTarget={tileListRef.current}
        />
      ))}
    </div>
  );
};
